import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({
  selector: '[appPlaceholder]',
  standalone: false,
})
export class PlaceholderDirective {
  viewContainerRef = inject(ViewContainerRef);
}
